import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import publicHelpers from 'globals/helpers/public-helpers';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

export interface DragOption { id: number | string, title: string }

@Component({
    selector: 'drag-dialog',
    template: `
<dialog-wrapper
  [backgroundColor]="data.backgroundColor || defaultColor"
  [dialogTitle]="data.title"
  [smallTitle]="true"
  [tiny]="true"
  [disabled]="false"
  [showClose]="false"
  [giveMeTwenty]="true"
  [titleHeight]="40"
  (submit)="dialogRef.close(data)"
  cdkDropList
  [cdkDropListData]="data.options"
  (cdkDropListDropped)="dropOption($event)"
>
  <div class="instructions" *ngIf="data.instructions" [innerHTML]="helpers.strWithBreak(data.instructions)"></div>
  <div class="check-holder card"  *ngFor="let opt of data.options" color="primary" cdkDrag>
    <icon class="handle" cdkDragHandle matIcon="drag_indicator"></icon>
    <div class="title">{{ opt.title }}</div>
  </div>
</dialog-wrapper>
`,
    styles: [`
    .instructions { margin-bottom: 15px; }
    .check-holder { display: flex; margin-bottom: 10px; }
    .check-holder.card { padding: 5px; margin-bottom: 5px; border-radius: 6px; border: 1px solid #ddd; }
    mat-checkbox { margin-right: 10px; }
    .handle { color: #999; cursor: pointer; margin-right: 5px; } 
  `],
    styleUrls: ['../../modules/sponsors/rank-select.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, CommonModule, IconComponent, CdkDropList, CdkDragHandle, CdkDrag],
})
export class DragDialogComponent {
  defaultColor: string = null
  helpers = publicHelpers

  constructor(
    public dialogRef: MatDialogRef<DragDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DragDialogData,
  ) {}

  dropOption(event: CdkDragDrop<DragOption[]>) {
    moveItemInArray(this.data.options, event.previousIndex, event.currentIndex);
  }
}

export interface DragDialogData {
  title: string
  instructions: string
  backgroundColor: string
  options: DragOption[]
}